<div class="testimonial-card" *ngFor="let testimonial of testimonials">
  <div class="avatar">
    <motif-avatar
      size="large"
      [userName]="testimonial.ownerName"
      [src]="testimonial.baseImg"
    ></motif-avatar>
    <label class="name">{{ testimonial.ownerName }}</label>
  </div>
  <div class="testimonial" [title]="testimonial.sharedDetails">
    {{ testimonial.sharedDetails }}
  </div>
</div>
